import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "../../assets/jss/material-dashboard-pro-react/components/cardTextStyle";
import { makeStyles } from "../../utils/barrels/material-ui-core";

const useStyles = makeStyles(styles);

export default function CardText(props) {
	const classes = useStyles();
	const { className, children, color, ...rest } = props;
	const cardTextClasses = classNames({
		[classes.cardText]: true,
		[classes[`${color}CardHeader`]]: color,
		[className]: className !== undefined,
	});
	return (
		<div className={cardTextClasses} {...rest}>
			{children}
		</div>
	);
}

CardText.propTypes = {
	className: PropTypes.string,
	color: PropTypes.oneOf([
		"warning",
		"success",
		"danger",
		"info",
		"primary",
		"rose",
	]),
	children: PropTypes.node,
};
